import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0234 = React.lazy(() => import('./symbols/0234_text_align_left_paragraph'));
const Symbol0235 = React.lazy(() => import('./symbols/0235_text_align_center_paragraph'));
const Symbol0236 = React.lazy(() => import('./symbols/0236_text_align_right_paragraph'));
const Symbol0237 = React.lazy(
  () => import('./symbols/0237_text_align_justify_last_line_left_paragraph')
);
const Symbol0238 = React.lazy(
  () => import('./symbols/0238_text_align_justify_last_line_right_paragraph')
);
const Symbol0239 = React.lazy(() => import('./symbols/0239_text_align_justify_paragraph'));
const Symbol0240 = React.lazy(() => import('./symbols/0240_text_align_right_indent'));
const Symbol0241 = React.lazy(() => import('./symbols/0241_text_align_left_indent'));
const Symbol0242 = React.lazy(() => import('./symbols/0242_text_line_height_leading'));
const Symbol0243 = React.lazy(() => import('./symbols/0243_text_line_height_leading'));
const Symbol0244 = React.lazy(() => import('./symbols/0244_text_bullets_list'));
const Symbol0245 = React.lazy(() => import('./symbols/0245_text_numbered_list'));
const Symbol0246 = React.lazy(() => import('./symbols/0246_text_font_size_smaller'));
const Symbol0247 = React.lazy(() => import('./symbols/0247_text_font_size_larger'));
const Symbol0248 = React.lazy(() => import('./symbols/0248_text_paragraph_indent_right'));
const Symbol0249 = React.lazy(() => import('./symbols/0249_text_paragraph_indent_left'));
const Symbol0250 = React.lazy(() => import('./symbols/0250_text_line_order'));
const Symbol0251 = React.lazy(() => import('./symbols/0251_text_paragraph_line_spacing'));
const Symbol0252 = React.lazy(() => import('./symbols/0252_text_spelling_check'));
const Symbol0253 = React.lazy(() => import('./symbols/0253_image_frame_size_rotate_resize'));
const Symbol0254 = React.lazy(() => import('./symbols/0254_copy'));
const Symbol0255 = React.lazy(() => import('./symbols/0255_paste_clipboard'));
const Symbol0256 = React.lazy(() => import('./symbols/0256_input_box_text_edit'));
const Symbol0257 = React.lazy(() => import('./symbols/0257_button'));
const Symbol0258 = React.lazy(() => import('./symbols/0258_code_html'));
const Symbol0259 = React.lazy(() => import('./symbols/0259_code_html'));
const Symbol0260 = React.lazy(() => import('./symbols/0260_link_url_chain_hyperlink'));
const Symbol0261 = React.lazy(() => import('./symbols/0261_unlink_url_unchain_hyperlink'));
const Symbol0262 = React.lazy(() => import('./symbols/0262_remove_clear_text_style'));
const Symbol0263 = React.lazy(() => import('./symbols/0263_text_font_typography'));
const Symbol0264 = React.lazy(() => import('./symbols/0264_text_style_bold'));
const Symbol0265 = React.lazy(() => import('./symbols/0265_text_style_italic'));
const Symbol0266 = React.lazy(() => import('./symbols/0266_text_style_underline'));
const Symbol0267 = React.lazy(() => import('./symbols/0267_text_style_strikethrough'));
const Symbol0268 = React.lazy(() => import('./symbols/0268_text_style_superscript'));
const Symbol0269 = React.lazy(() => import('./symbols/0269_text_style_subscript'));
const Symbol0270 = React.lazy(() => import('./symbols/0270_image_frame_crop_resize'));
const Symbol0271 = React.lazy(() => import('./symbols/0271_text_image_align_wrap'));
const Symbol0272 = React.lazy(() => import('./symbols/0272_text_image_align_top_bottom'));
const Symbol0273 = React.lazy(() => import('./symbols/0273_video_multimedia_movie'));

export interface IProps {}

const Text: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0234_text_align_left_paragraph" symbol={<Symbol0234 />} />
      <LazySymbol id="0235_text_align_center_paragraph" symbol={<Symbol0235 />} />
      <LazySymbol id="0236_text_align_right_paragraph" symbol={<Symbol0236 />} />
      <LazySymbol id="0237_text_align_justify_last_line_left_paragraph" symbol={<Symbol0237 />} />
      <LazySymbol id="0238_text_align_justify_last_line_right_paragraph" symbol={<Symbol0238 />} />
      <LazySymbol id="0239_text_align_justify_paragraph" symbol={<Symbol0239 />} />
      <LazySymbol id="0240_text_align_right_indent" symbol={<Symbol0240 />} />
      <LazySymbol id="0241_text_align_left_indent" symbol={<Symbol0241 />} />
      <LazySymbol id="0242_text_line_height_leading" symbol={<Symbol0242 />} />
      <LazySymbol id="0243_text_line_height_leading" symbol={<Symbol0243 />} />
      <LazySymbol id="0244_text_bullets_list" symbol={<Symbol0244 />} />
      <LazySymbol id="0245_text_numbered_list" symbol={<Symbol0245 />} />
      <LazySymbol id="0246_text_font_size_smaller" symbol={<Symbol0246 />} />
      <LazySymbol id="0247_text_font_size_larger" symbol={<Symbol0247 />} />
      <LazySymbol id="0248_text_paragraph_indent_right" symbol={<Symbol0248 />} />
      <LazySymbol id="0249_text_paragraph_indent_left" symbol={<Symbol0249 />} />
      <LazySymbol id="0250_text_line_order" symbol={<Symbol0250 />} />
      <LazySymbol id="0251_text_paragraph_line_spacing" symbol={<Symbol0251 />} />
      <LazySymbol id="0252_text_spelling_check" symbol={<Symbol0252 />} />
      <LazySymbol id="0253_image_frame_size_rotate_resize" symbol={<Symbol0253 />} />
      <LazySymbol id="0254_copy" symbol={<Symbol0254 />} />
      <LazySymbol id="0255_paste_clipboard" symbol={<Symbol0255 />} />
      <LazySymbol id="0256_input_box_text_edit" symbol={<Symbol0256 />} />
      <LazySymbol id="0257_button" symbol={<Symbol0257 />} />
      <LazySymbol id="0258_code_html" symbol={<Symbol0258 />} />
      <LazySymbol id="0259_code_html" symbol={<Symbol0259 />} />
      <LazySymbol id="0260_link_url_chain_hyperlink" symbol={<Symbol0260 />} />
      <LazySymbol id="0261_unlink_url_unchain_hyperlink" symbol={<Symbol0261 />} />
      <LazySymbol id="0262_remove_clear_text_style" symbol={<Symbol0262 />} />
      <LazySymbol id="0263_text_font_typography" symbol={<Symbol0263 />} />
      <LazySymbol id="0264_text_style_bold" symbol={<Symbol0264 />} />
      <LazySymbol id="0265_text_style_italic" symbol={<Symbol0265 />} />
      <LazySymbol id="0266_text_style_underline" symbol={<Symbol0266 />} />
      <LazySymbol id="0267_text_style_strikethrough" symbol={<Symbol0267 />} />
      <LazySymbol id="0268_text_style_superscript" symbol={<Symbol0268 />} />
      <LazySymbol id="0269_text_style_subscript" symbol={<Symbol0269 />} />
      <LazySymbol id="0270_image_frame_crop_resize" symbol={<Symbol0270 />} />
      <LazySymbol id="0271_text_image_align_wrap" symbol={<Symbol0271 />} />
      <LazySymbol id="0272_text_image_align_top_bottom" symbol={<Symbol0272 />} />
      <LazySymbol id="0273_video_multimedia_movie" symbol={<Symbol0273 />} />
    </>
  );
});

Text.displayName = 'Text';

export default Text;
